<template>
    <div class="card">
        <div class="text-center fw-bold fs-4 mt-2">
            <span class="border border-dark p-1"> DISCHARGE CERTIFICATE </span>
        </div>

        <div class="row p-1">
            <div class="col-md-6 col-12 col-lg-6">
                <label for="colFormLabel" class="form-label">Name</label>
                <input
                    :value="admissionInfo.patient ? admissionInfo.patient.full_name : ''"
                    name="serial"
                    type="text"
                    class="form-control"
                    readonly
                />
            </div>

            <div class="col-md-6 col-12 col-lg-3">
                <label for="colFormLabel" class="form-label">Age</label>
                <input
                    :value="getAge(admissionInfo.patient ? admissionInfo.patient.birthday : '')"
                    name="serial"
                    type="text"
                    class="form-control"
                    readonly
                />
            </div>

            <div class="col-md-6 col-12 col-lg-3">
                <label for="colFormLabel" class="form-label">Sex</label>
                <input
                    :value="admissionInfo.patient ? admissionInfo.patient.gender : ''"
                    type="text"
                    class="form-control"
                    readonly
                />
            </div>

            <div class="col-md-12 col-lg-6 py-1">
                <label for="colFormLabel" class="form-label">Ward / Bed No</label>
                <input
                    :value="admissionInfo.ward_bed_details"
                    type="text"
                    class="form-control"
                    readonly
                />
            </div>
        </div>

        <div class="row px-1">
            <div class="col-md-12 col-lg-6">
                <label for="colFormLabel" class="form-label"> Date of Admission</label>
                <input
                    :value="admissionInfo.admission_date ? formatDateToDdMmYy(admissionInfo.admission_date) : ''"
                    class="form-control"
                    readonly
                />
            </div>

            <div class="col-md-12 col-lg-6">
                <label for="colFormLabel" class="form-label">Date of Discharge</label>
                <input
                    name="datetime"
                    type="datetime-local"
                    class="form-control"
                    v-model="selectedDischargeDate"
                />
            </div>
        </div>

        <div class="mt-1">
            <div class="p-2">
                <h3>Diagnosis</h3>
            </div>
            <div
                v-for="(note, index) in notes"
                :key="index"
                class="row p-1 px-2"
              >
                <div class="col-md-12 col-lg-4">
                  <span>{{ note.name }}</span>
                </div>
                <div class="col-lg-8">
                    <AsyncSelect
                        placeholder="Select Notes"
                        v-model="note.note"
                        :api-service="noteNameByType"
                        :additional-query="{ type: note.type }"
                        :label="'name'"
                        :reduce="item => item.name"
                        :is-new-added="true"
                        :is-multiple="true"
                        @newAdd="handleNewAdded"
                    />
                </div>
            </div>
        </div>

        <div class="row p-1">
            <div class="col-md-12 col-lg-12">
                <label for="colFormLabel" class="col-form-label"> NAME OF UNIT CHIEF </label>
                <v-select
                    v-model="selectedHumanResource"
                    placeholder="Select" class="w-100" 
                    :options="consultants" label="name"
                    :reduce="(name) => name"
                    :multiple="true"
                />
            </div>

            <div class="col-md-12 col-lg-12 mt-1">
                <label for="colFormLabel" class="form-label">ASISTANT PROFESSOR</label>
                <v-select
                    v-model="selectedAdmitted"
                    placeholder="Select" class="w-100" 
                    :options="admittedByUsers" label="name"
                    :reduce="(name) => name"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, inject, onMounted, reactive, ref, watch } from 'vue';
import handleHospital from '@/services/modules/hospital';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

import { dateOfBirthConvertToAge, formatDateToDdMmYy } from '@/services/utils/global';
const { noteNameByType, storeNote } = handleHospital();

const props = defineProps({
    companyInfo: {
        type: Object,
    },
    admissionInfo: {
        type: Object,
    },
    dischargeDate: {
        type: String
    },
    consultants: {
        type: Array,
    },
    admittedByUsers: {
        type: Array,
    },
    notes: {
      type: Array,
      required: true
    },
    admittedBy: {
        type: Object
    },
    humanResource: {
        type: Array
    }
});

const emit = defineEmits([
    'update:humanResource',
    'update:admittedBy',
    'update:dischargeDate'
]);

const selectedHumanResource = computed({
    get: () => props.humanResource,
    set: (val) => emit('update:humanResource', val),
});

const selectedAdmitted = computed({
    get: () => props.admittedBy,
    set: (val) => emit('update:admittedBy', val),
});

const selectedDischargeDate = computed({
    get: () => props.dischargeDate,
    set: (val) => emit('update:dischargeDate', val),
});

const handleNewAdded = async (newOption) => {
  const res = await storeNote({
    company_id: props.companyInfo?.id,
    type: 'diagnosis',
    name: newOption.name,
    status: 'active',
  });
  if (!res.status) {
    console.log('Something went wrong');
  }
};

const getAge = (birthday) => {
    if(!birthday) return '';
    const {year} = dateOfBirthConvertToAge(birthday);
    return year + ' years';
}

</script>

<style scoped>
</style>